import { render, staticRenderFns } from "./VideoEventCarousel.vue?vue&type=template&id=638874ee&scoped=true"
import script from "./VideoEventCarousel.vue?vue&type=script&lang=js"
export * from "./VideoEventCarousel.vue?vue&type=script&lang=js"
import style0 from "./VideoEventCarousel.vue?vue&type=style&index=0&id=638874ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638874ee",
  null
  
)

export default component.exports